module.exports = __webpack_public_path__ + "static/affordable-844d6e5c7c071ddd7aa836356b780d09.svg";